var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert alert-danger text-center space-box-alert-custom" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-b-md" },
        [
          _vm._v("設定画面は"),
          _c(
            "router-link",
            { attrs: { to: { path: "/warehouse-amazon/amazon-info" } } },
            [_vm._v("こちら")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-b-md" }, [
      _vm._v("Amazonとのデータ連携を行ってください "),
      _c("br"),
      _vm._v(
        " セールモンスターへ出品する場合は、Amazonとのデータ連携が必要です。"
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-495d6337", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495d6337","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvalidSettingSpAccount.vue
// module id = null
// module chunks = 